import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Button from '@material-ui/core/Button';
import LaunchIcon from '@material-ui/icons/Launch';
import Link from '@material-ui/core/Link';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';

const UrlEvent = "https://www.aist.asn.au/Events/ASI";
const UrlFacilitators = "https://www.aist.asn.au/Events/ASI/Speakers-Facilitators";

const useStyles = makeStyles(theme => ({
  breadcrumbs: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  box: {
  },
  title: {
  },
  subtitle: {
    textTransform: 'uppercase',
    letterSpacing: '1px'
  },
  link: {
    fontSize: '0.7em',
    fontWeight: 400,
    color: '#fff',
    textTransform: 'uppercase',
  },
  icon: {
    color: '#ccc',
    fill: '#ccc',
    width: '12px',
    height: '12px',
    marginTop: '3px'
  },
  paragraph: {
    whiteSpace: 'pre-line',
    marginBottom: theme.spacing(1)
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },

}));

export default (props) => {
  const classes = useStyles();
  return (
    <>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" className={classes.icon} />} aria-label="breadcrumb" className={classes.breadcrumbs}>
        <Link color="inherit" href={UrlEvent} target='_blank' className={classes.link} > AIST </Link>
        <Link color="inherit" href={`/${props.userId}/home`} className={classes.link} > ASI 2020 </Link>
        <Link color="inherit" href={`/${props.userId}/event/${props.config.id}`} className={classes.link} > {props.config.id} </Link>
      </Breadcrumbs>
      <h2 className={classes.title}>ASI 2020 | {props.config.title}</h2>
      <h5 className={classes.subtitle}>{props.config.subtitle}</h5>
      <p className={classes.paragraph} dangerouslySetInnerHTML={{ __html: props.config.description }} />
      <div>
        <Button variant='contained' color='primary' size='small' startIcon={<HomeOutlinedIcon />} href={`/${props.userId}/home`} disableElevation className={classes.button}>Back to Home</Button>
        <Button variant='contained' color='primary' size='small' startIcon={<LaunchIcon />} href={UrlFacilitators} target='_blank' disableElevation className={classes.button}>Speakers &amp; Facilitators Bios</Button>
      </div>
    </>
  );
}